<template>
  <div class="bg-white rounded-full py-3 px-12 flex justify-between w-full">
    <slot name="left" />
    <slot name="right" />
  </div>
</template>
